(function(){
  function initHub(hub){
    if(!hub || hub.dataset.simHubReady==='1') return;
    hub.dataset.simHubReady='1';
    const suffix=(hub.id||'').replace(/^simHub-/, '');
    const frame=document.getElementById('simHubFrame-'+suffix);
    if(!frame) return;
    const map={tetine:'simTplTetine-'+suffix,doudou:'simTplDoudou-'+suffix,porte:'simTplPorte-'+suffix};
    const labels={tetine:'Attache-tétine',doudou:'Attache-doudou',porte:'Porte-clés 10 cm'};
    let ro=null, timer=null, currentKind='tetine';

    const params=new URLSearchParams(location.search);
    const coffretMode=params.get('coffret')==='1';
    const coffretVariant=Number(params.get('variant')||0);
    const requested=(params.get('items')||'tetine').split(',').map(x=>x.trim()).filter(x=>map[x]);
    const coffretItems=[...new Set(requested.length?requested:['tetine'])];
    const saved={};
    let adding=false;

    function fitFrame(){
      try{
        const doc=frame.contentDocument;if(!doc) return;
        const body=doc.body, html=doc.documentElement;if(!body||!html) return;
        const h=Math.max(body.scrollHeight,body.offsetHeight,html.clientHeight,html.scrollHeight,html.offsetHeight);
        if(h>200) frame.style.height=(h+8)+'px';
      }catch(e){}
    }
    function watchHeight(){
      if(ro){try{ro.disconnect();}catch(e){}}
      if(timer) clearInterval(timer);
      try{
        const doc=frame.contentDocument;
        if(doc && window.ResizeObserver){ro=new ResizeObserver(fitFrame);if(doc.documentElement)ro.observe(doc.documentElement);if(doc.body)ro.observe(doc.body);}
      }catch(e){}
      fitFrame();setTimeout(fitFrame,100);setTimeout(fitFrame,500);timer=setInterval(fitFrame,1200);
    }
    function setCoffretUi(){
      if(!coffretMode) return;
      hub.classList.add('sim-hub--coffret');
      const title=hub.querySelector('.sim-hub__title');
      const intro=hub.querySelector('.sim-hub__intro');
      if(title) title.textContent='Personnalisez votre coffret';
      if(intro) intro.textContent='Personnalisez chaque élément puis validez. Votre parfum reste celui choisi sur la fiche produit.';
      hub.querySelectorAll('.sim-hub__btn').forEach(btn=>{
        const show=coffretItems.includes(btn.dataset.sim);
        btn.style.display=show?'':'none';
      });
    }
    function decorateFrame(){
      if(!coffretMode) return;
      try{
        const doc=frame.contentDocument;if(!doc) return;
        const btn=doc.getElementById('addToCartBtn');
        const idx=coffretItems.indexOf(currentKind);
        const last=idx===coffretItems.length-1;
        if(btn){btn.textContent=last?'Enregistrer et ajouter mon coffret au panier':'Enregistrer et continuer';btn.disabled=false;}
        if(currentKind==='porte'){
          const b10=doc.querySelector('[data-key-size="10"]');
          if(b10 && !b10.classList.contains('active')) b10.click();
          const b7=doc.querySelector('[data-key-size="7"]');
          if(b7) b7.style.display='none';
        }
      }catch(e){}
    }
    function openSim(kind){
      if(coffretMode && !coffretItems.includes(kind)) kind=coffretItems[0];
      const tpl=document.getElementById(map[kind]);if(!tpl) return;
      currentKind=kind;
      hub.querySelectorAll('.sim-hub__btn').forEach(function(btn){
        const active=btn.dataset.sim===kind;btn.classList.toggle('is-active',active);btn.setAttribute('aria-selected',active?'true':'false');
      });
      frame.onload=function(){watchHeight();decorateFrame();};
      let simHtml=tpl.value;
      simHtml=simHtml.split('__SIM_SCRIPT_JSON_OPEN__').join('<scr'+'ipt type="application/json">').split('__SIM_SCRIPT_OPEN__').join('<scr'+'ipt>').split('__SIM_SCRIPT_CLOSE__').join('</scr'+'ipt>');
      frame.srcdoc='<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"></head><body>'+simHtml+'</body></html>';
      try{history.replaceState(null,'',location.pathname+location.search+'#simulateur-'+kind);}catch(e){}
    }
    function mergedProperties(){
      const out={'Personnalisation coffret':'Complète'};
      coffretItems.forEach(kind=>{
        const data=saved[kind];if(!data) return;
        Object.keys(data.properties||{}).forEach(key=>{
          const clean=key.charAt(0)==='_'?key.slice(1):key;
          const prefix=key.charAt(0)==='_'?'_':'';
          out[prefix+labels[kind]+' — '+clean]=String(data.properties[key]);
        });
      });
      return out;
    }
    function premiumTotalCents(){
      const bases={tetine:1500,doudou:1700,porte:1000};
      return coffretItems.reduce((total,kind)=>{
        const data=saved[kind]; if(!data) return total;
        return total+Math.max(0,(Number(data.priceCents)||0)-(bases[kind]||0));
      },0);
    }
    async function addCoffret(){
      if(adding) return;
      if(!coffretVariant){alert("La variante du coffret n'a pas été transmise. Revenez à la fiche produit et choisissez votre parfum.");return;}
      adding=true;
      try{
        const premium=premiumTotalCents();
        const props=mergedProperties();
        props['Suppléments premium']=premium?('+'+(premium/100).toFixed(2)+' €'):'Aucun';
        const items=[{id:coffretVariant,quantity:1,properties:props}];
        if(premium){
          const feeMap=(window.SIM_COFFRET_FEE_VARIANTS||{});
          let remaining=premium;
          const values=Object.keys(feeMap).map(Number).filter(v=>v>0&&feeMap[v]).sort((a,b)=>b-a);
          for(const value of values){
            while(remaining>=value){items.push({id:Number(feeMap[value]),quantity:1,properties:{'_Lié au coffret':'Oui','Supplément':(value/100).toFixed(2)+' €'}});remaining-=value;}
          }
          if(remaining!==0) throw new Error('fee-map');
        }
        async function postItems(batch){
          const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:batch})});
          if(!r.ok){
            let detail='';
            try{const j=await r.json();detail=j.description||j.message||'';}catch(_e){try{detail=await r.text();}catch(_e2){}}
            const err=new Error(detail||('Erreur panier '+r.status));err.status=r.status;throw err;
          }
          return r;
        }
        try{
          await postItems(items);
        }catch(groupErr){
          // Certains thèmes/boutiques refusent l'ajout groupé avec des produits techniques.
          // On retente proprement en ajoutant d'abord le coffret puis les suppléments.
          await postItems([items[0]]);
          for(let i=1;i<items.length;i++) await postItems([items[i]]);
        }
        location.href='/cart';
      }catch(e){
        adding=false;
        try{
          const d=frame.contentDocument,m=d&&d.getElementById('cartMessage'),b=d&&d.getElementById('addToCartBtn');
          if(m)m.textContent="Impossible d'ajouter le supplément au panier : "+(e&&e.message?e.message:'erreur Shopify');
          if(b){b.disabled=false;b.textContent='Réessayer';}
        }catch(err){}
      }
    }
    function onMessage(event){
      if(!coffretMode || event.source!==frame.contentWindow || !event.data || event.data.type!=='SIM_COFFRET_SAVE') return;
      const kind=event.data.kind;if(!coffretItems.includes(kind)) return;
      saved[kind]={properties:event.data.properties||{},priceCents:Number(event.data.priceCents)||0};
      const idx=coffretItems.indexOf(kind);
      if(idx<coffretItems.length-1) openSim(coffretItems[idx+1]); else addCoffret();
    }
    window.addEventListener('message',onMessage);
    hub.querySelectorAll('.sim-hub__btn').forEach(function(btn){btn.addEventListener('click',function(){openSim(btn.dataset.sim);});});
    setCoffretUi();
    const hash=(location.hash||'').replace('#simulateur-','');
    openSim(coffretMode?coffretItems[0]:(map[hash]?hash:'tetine'));
  }
  function initAll(){document.querySelectorAll('.sim-hub').forEach(initHub);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initAll); else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();
